// Simple keyboard-shortcut helpers. Shortcuts are stored as strings like
// "Ctrl+Alt+D", "Cmd+Shift+Z" — the frontend parses them and compares
// against native `KeyboardEvent`s.

export const IS_MAC = typeof navigator !== "undefined"
  && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");

// Return the correct binding string for the current OS.
export function osBinding(cfg) {
  if (!cfg) return "";
  return IS_MAC ? cfg.mac : cfg.win;
}

// Parse "Ctrl+Alt+D" → { ctrl, meta, alt, shift, key }.
export function parseShortcut(str) {
  if (!str) return null;
  const parts = str.split("+").map((p) => p.trim().toLowerCase()).filter(Boolean);
  if (parts.length === 0) return null;
  const key = parts.pop();
  return {
    // Treat Cmd and Ctrl as interchangeable in matching — Mac users press Cmd,
    // Windows/Linux users press Ctrl; either primary-modifier is accepted.
    ctrl:  parts.includes("ctrl") || parts.includes("cmd") || parts.includes("meta"),
    alt:   parts.includes("alt")  || parts.includes("option") || parts.includes("opt"),
    shift: parts.includes("shift"),
    key,
  };
}

// Does the given KeyboardEvent match the parsed shortcut?
export function matchesShortcut(e, str) {
  const p = parseShortcut(str);
  if (!p) return false;
  const primary = e.ctrlKey || e.metaKey;
  return (
    (e.key || "").toLowerCase() === p.key &&
    primary === p.ctrl &&
    e.altKey === p.alt &&
    e.shiftKey === p.shift
  );
}
